module.exports = __webpack_public_path__ + "img/reading-2-en.7897dbff.png";